import React from 'react';

import { Space, Typography } from '@sravni/react-design-system';
import { useStyles } from '@sravni/react-utils';

import { ICompanyResponse, IRepresentative } from '../../interfaces/reviews';
import { UserAvatar } from '../UserAvatar';

import styles from './representative.module.scss';

export interface IRepresentativeProps {
  representative: IRepresentative;
  response: ICompanyResponse;
  logo: string;
}

export const Representative: React.FC<IRepresentativeProps> = ({
  representative,
  response,
  logo,
}: IRepresentativeProps) => {
  const cx = useStyles(styles);

  if (!representative?.id) return null;

  let responseTime = !response?.avgResponseTime ? null : 'часа';
  const { days, hours } = response?.avgResponseTime ?? {};

  if (days > 1 || (days === 1 && hours > 0)) {
    responseTime = 'нескольких дней';
  } else if ((days === 1 && hours === 0) || (hours >= 12 && hours <= 24)) {
    responseTime = 'суток';
  } else if (hours > 1) {
    responseTime = 'нескольких часов';
  }

  return (
    <Space direction={'vertical'} size={8} className={cx('wrapper')} align={'center'}>
      <UserAvatar userId={representative.id} logo={logo} isRepresentative />
      <Typography.Heading level={4} className={'h-text-center'}>
        Представитель ответит в течение {responseTime}
      </Typography.Heading>
    </Space>
  );
};
